import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/scss/bootstrap.scss";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "react-quill/dist/quill.snow.css";
import "./css/table.scss";
import { Toast } from "primereact/toast";
import React, { Suspense, useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.scss";
import "./ResponsiveCSS/responsive.scss";
import Assessment from "./components/Assessment";
import AutoLogin from "./common/login/AutoLogin";
import "./scss/sidebar.scss";
import "./scss/style.scss";
import "./css/theme-variables.css";
import Error401 from "./server/errorpages/error401";
import ErrorBoundary from "./ErrorBoundary";
import { initializeTheme } from "./utils/themeUtils";

const loading = (
  <div
    className="pt-3 text-center"
    style={{
      height: "90vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div className="spinner-border" role="status">
      <span className="sr-only"></span>
    </div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./common/layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./common/login/Login"));
const ResetPassword = React.lazy(() =>
  import("./common/ResetPassword/ResetPassword")
);
const FeedbackForm = React.lazy(() =>
  import("./admin/TrainingManagement/InPersonCourses/FeedbackForm")
);
const EmployeeTrainingRecord = React.lazy(() =>
  import("./common/TrainingRecord/EmployeeTrainingRecord")
);

// Lazy-load heavy players to keep main bundle smaller
const ContentPlayer = React.lazy(() => import("./components/ContentPlayer"));
const ContentPlayersuperadmin = React.lazy(() =>
  import("./components/ContentPlayersuperadmin")
);
const ContentPlayeradmin = React.lazy(() =>
  import("./components/ContentPlayeradmin")
);

const API_URL = process.env.REACT_APP_API_URL;

// Initialize theme on app load
initializeTheme();

const App = () => {
  const toast = useRef(null);

  // Set the browser tab title from the stored portal name on every load/refresh
  useEffect(() => {
    const isValid = (v) => v && v !== "null" && v !== "undefined" && v.trim();
    const storedTitle = [
      localStorage.getItem("logoText"),
      localStorage.getItem("OrgLogoText"),
      localStorage.getItem("orgLogoText"),
    ].find(isValid);
    if (storedTitle) {
      document.title = storedTitle.trim();
    }
  }, []);

  return (
    <ErrorBoundary showDetails={true}>
      <div style={{ width: "100%", height: "100%" }}>
        <Toast ref={toast} />
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/" name="Login Page" element={<Login />} />
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route
              exact
              path="/autologin"
              name="Auto Login"
              element={<AutoLogin />}
            />
            <Route
              exact
              path="/auth/saml/callback"
              name="SAML Callback"
              element={<AutoLogin />}
            />
            <Route path="/resetpassword/:token" element={<ResetPassword />} />
            <Route
              path="/first-time-reset/:token"
              element={<ResetPassword />}
            />
            <Route path="/classcoursefeedback" element={<FeedbackForm />} />
            {/* Verified Transcript / QC Record Routes */}
            <Route
              path="/:parentOrg/:childOrg/qc/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/:parentOrg/qc/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/qc/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/:parentOrg/:childOrg/qrc/index/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/:parentOrg/qrc/index/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/qrc/index/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/qrc/verify/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/saferhublms/qrc/index/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              path="/training-record/:username"
              name="Employee Training Record"
              element={<EmployeeTrainingRecord />}
            />
            <Route
              exact
              path="/error401"
              name="Error Page"
              element={<Error401 />}
            />
            <Route
              exact
              path="/elearning/content/player"
              name="studentplayer"
              element={<ContentPlayer />}
            />

            <Route
              exact
              path="/elearning/player"
              name="superadminplayer"
              element={<ContentPlayersuperadmin />}
            />
            <Route
              exact
              path="/elearning/content"
              name="adminplayer"
              element={<ContentPlayeradmin />}
            />
            <Route
              exact
              path="/assessment/content/quizandsurvey"
              name="assessment"
              element={<Assessment />}
            />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </div>
    </ErrorBoundary>
  );
};

export default App;
